if (!customElements.get('fabric-tooltip')) {
  customElements.define(
    'fabric-tooltip',
    class FabricTooltip extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('product-info');
        this.mediaGalleryWrapper = this.section.querySelector('.product__media-wrapper');
        this.tooltip = this.querySelector('.fabric__tooltip');

        this.setLeftPosition();
        window.addEventListener('resize', this.setLeftPosition.bind(this));
      }

      setLeftPosition(){
        const mediaGalleryWidth = this.mediaGalleryWrapper.getBoundingClientRect().width;
        const mediaGalleryLeft = this.mediaGalleryWrapper.getBoundingClientRect().left;
        this.position = (mediaGalleryLeft + mediaGalleryWidth);
        this.style.setProperty('--tooltip-left-position', `${this.position}px`);
      }
    }
  );
}